export const actionTypes = {
    SET_BOT_IMPACT_GRAPH_DATA: 'SET_BOT_IMPACT_GRAPH_DATA',
    SET_IMPACT_GRAPH_CANCEL_TOKEN: 'SET_IMPACT_GRAPH_CANCEL_TOKEN',
    IS_IMPACT_GRAPH_FETCHING: 'IS_IMPACT_GRAPH_FETCHING'
}